var _circle, _circle2, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSilverwareBadge = function SvgSilverwareBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FFF9C4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12.5,
    stroke: "#18181B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#silverware-badge_svg__clip0_115_3646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.667 12v5.333h2v5.334H22V9.333c-1.84 0-3.333 1.494-3.333 2.667zm-3.334 2H14V9.333h-1.333V14h-1.334V9.333H10V14a2.666 2.666 0 002.667 2.667v6H14v-6A2.666 2.666 0 0016.667 14V9.333h-1.334V14z",
    fill: "#27272A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "silverware-badge_svg__clip0_115_3646"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8 8)",
    d: "M0 0h16v16H0z"
  })))));
};

export default SvgSilverwareBadge;